import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/surajsajjan/Desktop/rpcollege/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/surajsajjan/Desktop/rpcollege/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/activities/components/ActivitiesEvents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/activities/components/ActivitiesGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/activities/components/ActivitiesHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/app/components/ScrollProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/rpcollege/src/components/ui/WhatsAppFloatingButton.tsx");
